<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-12-03 16:49:03
 * @FilePath: \gcp-fe\src\app\shop\components\valueAddedService.vue
 * @Description: 增值服务
-->
<template>
  <div class="notice-list mt20">
    <div class="titleBoxs">
      <div class="title">{{ $t("valueAddedService.title") }}</div>
    </div>
    <div class="linkBox">
      <div class="linkBoxItem" v-for="(item, index) in linkList" :key="index">
        <div class="imgInfo">
          <img :src="item.img" alt="" srcset="" />
          <span>{{ item.title }}</span>
        </div>
        <i class="el-icon-right" @click="handleClick(item)"></i>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/config/store";
export default {
  data() {
    return {
      linkList: [
        {
          title: this.$t("valueAddedService.linkList.labelOne"),
          img: require("@/basa/assets/images/zz1.png"),
          key: 1
        },
        {
          title: this.$t("valueAddedService.linkList.labelTwo"),
          img: require("@/basa/assets/images/zz2.png"),
          key: 2
        },
        {
          title: this.$t("valueAddedService.linkList.labelThree"),
          img: require("@/basa/assets/images/zz3.png"),
          key: 3
        },
        {
          title: this.$t("valueAddedService.linkList.labelFour"),
          img: require("@/basa/assets/images/zz4.png"),
          key: 4
        }
      ]
    };
  },

  mounted() {},
  methods: {
    handleClick(item) {
      store.dispatch("setPageLoading", true);

      // 添加路由跳转后的处理
      const removeAfterEach = this.$router.afterEach(() => {
        store.dispatch("setPageLoading", false);
        removeAfterEach(); // 移除监听器
      });
      switch (item.key) {
        case 1:
          // 滚动到顶部
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          this.$router.push({ path: "/operationGuide" });
          break;
        case 2:
          // CA认证跳转链接：https://aimarket.iccec.cn/
          window.location.href = "https://aimarket.iccec.cn/digital-ca/";
          store.dispatch("setPageLoading", false);
          break;
        case 3:
          // 光速标讯跳转链接：https://aimarket.iccec.cn/share/
          window.location.href = "https://aimarket.iccec.cn/share/";
          store.dispatch("setPageLoading", false);
          break;
        case 4:
          window.location.href = `${this.$addUrlPerFix(
            process.env.VUE_APP_JR_URL
          )}`;
          store.dispatch("setPageLoading", false);
          break;

        default:
          break;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.mt20 {
  margin-top: 20px;
  padding-bottom: 20px;
}

.notice-list {
  // height: 230px;
  width: 1180px;
  margin: 0 auto;
  position: relative;

  .titleBoxs {
    text-align: center;
    .title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 24px;
      color: #181818;
      line-height: 33px;
      font-style: normal;
    }
  }
  .titleBoxs {
    margin-top: 20px;
  }

  .linkBox {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .linkBoxItem {
      width: 580px;
      height: 80px;
      background: #ffffff;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
      // padding: 0 20px;

      span {
        font-weight: 600;
        font-size: 18px;
        color: #181818;
        display: inline-block;
        margin-left: 20px;
      }

      .imgInfo {
        display: flex;
        align-items: center;
        margin-left: 47px;
      }

      i {
        color: #444444;
        display: inline-block;
        margin-right: 20px;
        cursor: pointer;
        font-size: 16px;
        font-weight: 500;
        // width: 20px;
        // height: 20px;
      }
    }
  }
}
</style>
